import { CurrencyFormValues } from './CurrenciesForm'
import { ExtendedProduct } from 'store/products/types'

export const toCurrencyFormValues = (product: ExtendedProduct): CurrencyFormValues => product.currency
